function overflow() {
    const lp = document.querySelector('[data-js="lp"]');
    if(lp) {
        const body = document.querySelector('body');
        body.classList.add('body-overflow');
    }
}

export default overflow;